// extracted by mini-css-extract-plugin
export default {"Alert":"Alert_Alert__zVXrM","holder":"Alert_holder__NMmvP"};